import React, { useEffect, useState } from "react";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import { Formik, Form, FieldArray } from "formik";
import CustomInput from "../../../CustomComponent/custom_input";
import CustomSelect from "../../../CustomComponent/custom_select";
import StepRoutes from "../../../Routes/steps_routes";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { useNavigate, useParams } from "react-router-dom";
import LoadingPage from "../../../Components/layouts/loading";
import { ReqForPaymentSchema } from "../../../Schemas/purchase/request_for_payment_schema";
import { ReqForPayInfo, ReqForPayLineItemInfo } from "../../../SchemaInfo/info";
import { getId } from "../../../Components/Functions/word.fun";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcMoneyTransfer } from "react-icons/fc";
import CustomTextArea from "../../../CustomComponent/custom_textarea";

const EditReqForPayment = () => {
  let { id } = useParams();

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [reqForPayInfo, setReqForPayInfo] = useState(ReqForPayInfo);
  const [loadingNew, setLoadingNew] = useState(false);
  //   const [projects, setProjects] = useState([]);
  const [data, setData] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [poNumber, setPoNumber] = useState([]);
  const [siKitOrders, setSIKitOrders] = useState([]);
  const [vendorBalance, setVendorBalance] = useState();
  const [oldReduceVendorAmount, setOldReduceVendorAmount] = useState(0);
  const [removeOldReduceAmount, setRemoveOldReduceAmount] = useState(false);

  useEffect(() => {
    performRequest("GET", "/materialPlanning/getAllMaterialList")
      .then((res) => {
        if (res.status === 200) {
          setData(res.data?.MaterialList);
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);
  //   useEffect(() => {
  //     performRequest("GET", "/siteInspection/getAllProjects")
  //       .then((res) => setProjects(res.data))
  //       .catch((err) => CustomErrorResponse(err));
  //   }, []);
  useEffect(() => {
    performRequest("GET", "/poDcPi/getAllVendorList")
      .then((res) => setVendors(res.data))
      .catch((err) => CustomErrorResponse(err));
  }, []);

  useEffect(() => {
    performRequest("GET", "/poDcPi/getPoNum")
      .then((res) => setPoNumber(res.data))
      .catch((err) => CustomErrorResponse(err));
  }, []);

  useEffect(() => {
    performRequest("GET", "/poDcPi/getAllSIKitList")
      .then((res) => setSIKitOrders(res.data))
      .catch((err) => CustomErrorResponse(err));
  }, []);

  const handelSubmit = (values, actions) => {
    const po = poNumber?.find((el) => el.poNumber === values.poNum);

    if (!po?.approveStatus && values.paymentfor !== "SI Kit Payment") {
      actions.setFieldError(
        "poNum",
        "Selected Purchase Order is not approved!"
      );
      actions.setSubmitting(false);
      return; // Stop submission
    }
    values = {
      ...values,
      invoicenumber: values?.invoicenumber?.trim(),
      amount:
        Number(values?.amount || 0) - Number(values?.reduceVendorAmount || 0),
    };
    const formData = new FormData();
    for (let key in values) {
      if (values[key] instanceof File || values[key] instanceof Blob) {
        formData.append(key, values[key]);
      } else if (typeof values[key] === "object" && values[key] !== null) {
        formData.append(key, JSON.stringify(values[key]));
      } else {
        formData.append(key, values[key]);
      }
    }

    setLoading(true);
    const headers = { "content-type": "multipart/form-data" };
    performRequest(
      "PATCH",
      `/request/updatereqforpayment/${id}`,
      formData,
      headers
    )
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Request For Payment Updated successfully!");
          navigate(`/req-for-payment/view/${id}`);
        } else {
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => {
        setLoading(false);
        actions.setSubmitting(false);
      });
  };

  const handleRemoveReducedAmount = async () => {
    try {
      setLoading(true);

      // Update UI
      setOldReduceVendorAmount(0);
      setRemoveOldReduceAmount(true);

      let data = { reduceVendorAmount: 0 };

      const res = await performRequest(
        "PATCH",
        `/request/reduced-amount/${id}`,
        data
      );

      if (res.status === 200) {
        Toast("success", "Reduced vendor amount removed successfully!");
      } else {
        Toast("error", "Error while removing reduced amount");
      }
    } catch (err) {
      console.error("Remove reduced amount error:", err);
      CustomErrorResponse(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoadingNew(true);
    performRequest("GET", `/request/getreqpaymentByID/${id}`)
      .then((res) => {
        if (res.status === 200) {
          const previousReduce = Number(
            res?.data?.reqStatus?.reduceVendorAmount || 0
          );

          console.log("previousReduce is", previousReduce);

          setOldReduceVendorAmount(previousReduce);
          setReqForPayInfo({
            ...res?.data?.reqStatus,
            reduceVendorAmount: 0,
          });
        } else {
          Toast("error", "Error while getting Request!");
        }
        setLoadingNew(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoadingNew(false));
  }, [id]);

  useEffect(() => {
    if (!reqForPayInfo?.poNum) return;

    const poNumberNew = getId(reqForPayInfo.poNum);

    if (!poNumberNew) return;

    console.log("poNumberNew is", poNumberNew);

    performRequest("GET", `/poDcPi/getVendorByPoNum/${poNumberNew}`)
      .then((res) => {
        if (res.status === 200) {
          setVendorBalance(res?.data?.totalPendingAmount || 0);
        } else {
          Toast("error", "Error while getting vendor balance!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, [reqForPayInfo?.poNum]);
  const checkTouched = (obj) => {
    if (
      obj.itemQuantity === "" &&
      obj.itemUnit === "" &&
      obj.particulars === ""
    ) {
      return false;
    } else {
      return true;
    }
  };

  if (loadingNew) {
    return <LoadingPage />;
  }
  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcMoneyTransfer />
                  Request For Payment
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">Edit Request For Payment</h2>
            </div>

            <Formik
              initialValues={reqForPayInfo}
              validationSchema={ReqForPaymentSchema}
              onSubmit={handelSubmit}
            >
              {(props) => (
                <Form>
                  <div className="card-body">
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Payment For
                      </label>
                      <div className="w-100 col d-flex align-items-center gap-3">
                        <div className="form-check">
                          <input
                            type="radio"
                            id="materialInventory"
                            name="paymentfor"
                            value="Material Inventory"
                            className="form-check-input"
                            onChange={props.handleChange}
                            checked={
                              props.values.paymentfor === "Material Inventory"
                            }
                          />
                          <label
                            htmlFor="materialInventory"
                            className="form-check-label"
                          >
                            Material Inventory
                          </label>
                        </div>

                        <div className="form-check">
                          <input
                            type="radio"
                            id="vendorPayment"
                            name="paymentfor"
                            value="Vendor Payment"
                            className="form-check-input"
                            onChange={props.handleChange}
                            checked={
                              props.values.paymentfor === "Vendor Payment"
                            }
                          />
                          <label
                            htmlFor="vendorPayment"
                            className="form-check-label"
                          >
                            Vendor Payment
                          </label>
                        </div>
                        {/* <div className="form-check">
                          <input
                            type="radio"
                            id="advancedPayment"
                            name="paymentfor"
                            value="Advanced Payment"
                            className="form-check-input"
                            onChange={props.handleChange}
                            checked={
                              props.values.paymentfor === "Advanced Payment"
                            }
                          />
                          <label
                            htmlFor="advancedPayment"
                            className="form-check-label"
                          >
                            Advanced Payment
                          </label>
                        </div> */}
                        <div className="form-check">
                          <input
                            type="radio"
                            id="siKitPayment"
                            name="paymentfor"
                            value="SI Kit Payment"
                            className="form-check-input"
                            onChange={props.handleChange}
                            checked={
                              props.values.paymentfor === "SI Kit Payment"
                            }
                          />
                          <label
                            htmlFor="siKitPayment"
                            className="form-check-label"
                          >
                            SI Kit Payment
                          </label>
                        </div>
                      </div>
                    </div>
                    {props.values.paymentfor !== "SI Kit Payment" && (
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3 required">
                          PO Number
                        </label>
                        <div className="w-100 col">
                          <CustomSelect
                            type="text"
                            name="poNum"
                            onChange={(e) => {
                              props.handleChange(e);
                              props.setFieldValue("siKitForClientId", "");
                              props.setFieldValue("siKitForClient", "");
                              // getVendorDetails(e.target.value, props);
                            }}
                          >
                            <option value="">Select</option>
                            {poNumber?.map((item) => {
                              return (
                                <>
                                  <option value={item.poNumber}>
                                    {item?.poNumber?.replace(/\//g, " ")}
                                  </option>
                                  <hr className="m-0 p-0"></hr>
                                </>
                              );
                            })}
                          </CustomSelect>

                          {props.touched.poNum && props.errors.poNum && (
                            <p className="text-danger">{props.errors.poNum}</p>
                          )}
                        </div>
                      </div>
                    )}
                    {props.values.paymentfor === "SI Kit Payment" && (
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3 required">
                          SI kit for client
                        </label>
                        <div className="w-100 col">
                          <CustomSelect
                            type="text"
                            name="siKitForClientId"
                            onChange={(e) => {
                              props.handleChange(e);
                              let val = e.target.value;
                              let sikit = siKitOrders?.find(
                                (el) => el.id == val
                              );
                              props.setFieldValue(
                                "siKitForClient",
                                sikit.leadName
                              );
                              props.setFieldValue("poNum", "");
                            }}
                          >
                            <option value="">Select</option>
                            {siKitOrders?.map((item) => {
                              return (
                                <>
                                  <option value={item.id}>
                                    {item?.leadName}
                                  </option>
                                  <hr className="m-0 p-0"></hr>
                                </>
                              );
                            })}
                          </CustomSelect>

                          {props.touched.siKitForClientId &&
                            props.errors.siKitForClientId && (
                              <p className="text-danger">
                                {props.errors.siKitForClientId}
                              </p>
                            )}
                        </div>
                      </div>
                    )}
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Vendor</label>
                      <div className="w-100 col">
                        <CustomSelect
                          type="text"
                          name="vendor"
                          // disabled={
                          //   props.values.paymentfor === "Material Inventory"
                          // }
                        >
                          <option value="">Select</option>
                          {vendors?.map((item) => {
                            return (
                              <option key={item.id} value={item.id}>
                                {item.businessName}
                              </option>
                            );
                          })}
                        </CustomSelect>

                        {props.touched.vendor && props.errors.vendor && (
                          <p className="text-danger">{props.errors.vendor}</p>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Payment Type
                      </label>
                      <div className="w-100 col d-flex align-items-center gap-3">
                        <div className="form-check">
                          <input
                            type="radio"
                            id="advancedPayment"
                            name="paymentType"
                            value="Advanced Payment"
                            className="form-check-input"
                            onChange={props.handleChange}
                            checked={
                              props.values.paymentType === "Advanced Payment"
                            }
                          />
                          <label
                            htmlFor="advancedPayment"
                            className="form-check-label"
                          >
                            Advanced Payment
                          </label>
                        </div>

                        <div className="form-check">
                          <input
                            type="radio"
                            id="remainingPayment"
                            name="paymentType"
                            value="Remaining Payment"
                            className="form-check-input"
                            onChange={props.handleChange}
                            checked={
                              props.values.paymentType === "Remaining Payment"
                            }
                          />
                          <label
                            htmlFor="remainingPayment"
                            className="form-check-label"
                          >
                            Remaining Payment
                          </label>
                        </div>

                        <div className="form-check">
                          <input
                            type="radio"
                            id="fullPayment"
                            name="paymentType"
                            value="Full Payment"
                            className="form-check-input"
                            onChange={props.handleChange}
                            checked={
                              props.values.paymentType === "Full Payment"
                            }
                          />
                          <label
                            htmlFor="vendorPayment"
                            className="form-check-label"
                          >
                            Full Payment
                          </label>
                        </div>
                      </div>

                      {props.touched.paymentType &&
                        props.errors.paymentType && (
                          <p className="text-danger">
                            {props.errors.paymentType}
                          </p>
                        )}
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        {props.values.paymentType === "Remaining Payment"
                          ? "Advanced Payment Invoice Num / PI Num"
                          : "Invoice Num / PI Num"}
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="invoicenumber" />

                        {props.touched.invoicenumber &&
                          props.errors.invoicenumber && (
                            <p className="text-danger">
                              {props.errors.invoicenumber}
                            </p>
                          )}
                      </div>
                    </div>
                    {props.values.paymentType === "Remaining Payment" ? (
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Remaining Payment Invoice Num / PI Num
                        </label>
                        <div className="w-100 col">
                          <CustomInput type="text" name="remainingInvoicenum" />

                          {props.touched.remainingInvoicenum &&
                            props.errors.remainingInvoicenum && (
                              <p className="text-danger">
                                {props.errors.remainingInvoicenum}
                              </p>
                            )}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Amount
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="amount" />

                        {props.touched.amount && props.errors.amount && (
                          <p className="text-danger">{props.errors.amount}</p>
                        )}
                      </div>
                    </div>
                    {/* <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Reduce Vendor Amount
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="reduceVendorAmount" />

                        {props.touched.reduceVendorAmount &&
                          props.errors.reduceVendorAmount && (
                            <p className="text-danger">
                              {props.errors.reduceVendorAmount}
                            </p>
                          )}
                      </div>
                    </div> */}
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Reduce Vendor Amount
                      </label>

                      <div className="w-100 col">
                        <CustomInput type="text" name="reduceVendorAmount" />

                        {props.touched.reduceVendorAmount &&
                          props.errors.reduceVendorAmount && (
                            <p className="text-danger">
                              {props.errors.reduceVendorAmount}
                            </p>
                          )}

                        {/* Previous Reduce Amount */}
                        {oldReduceVendorAmount > 0 && (
                          <div className="mt-2 d-flex align-items-center gap-2">
                            <span className="text-muted">
                              Previously Reduced:{" "}
                              <strong>
                                ₹
                                {Number(oldReduceVendorAmount).toLocaleString(
                                  "en-IN"
                                )}
                              </strong>
                            </span>

                            <button
                              type="button"
                              className="btn btn-sm btn-danger"
                              onClick={handleRemoveReducedAmount}
                            >
                              Remove
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Upload Final Invoice
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="invoiceImg"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue("invoiceImg", e.target.files[0])
                          }
                        />
                        {props.touched.invoiceImg &&
                          props.errors.invoiceImg && (
                            <p className="text-danger">
                              {props.errors.invoiceImg}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Upload GRN
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="uploadGRN"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue("uploadGRN", e.target.files[0])
                          }
                        />
                        {props.touched.uploadGRN && props.errors.uploadGRN && (
                          <p className="text-danger">
                            {props.errors.uploadGRN}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Upload Payment Img
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="paymentImg"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue("paymentImg", e.target.files[0])
                          }
                        />
                        {props.touched.paymentImg &&
                          props.errors.paymentImg && (
                            <p className="text-danger">
                              {props.errors.paymentImg}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Notes</label>
                      <div className="w-100 col">
                        <CustomTextArea type="text" name="notes" />

                        {props.touched.notes && props.errors.notes && (
                          <p className="text-danger">{props.errors.notes}</p>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row mt-3">
                      <label className="w-25 form-label col-3 ">
                        Vendor Balance Availble :
                      </label>
                      <div className="w-100 col">
                        {/* <h2>{vendorBalance}&nbsp;Rs</h2> */}
                        <span className="fs-2" style={{ fontWeight: "600" }}>
                          {vendorBalance && <span>₹</span>}
                          {vendorBalance
                            ? Number(vendorBalance).toLocaleString("en-IN")
                            : "0"}
                        </span>
                        {/* <CustomInput
                          type="text"
                          name="accountholderName"
                          value={
                            props?.values?.accountholderName ||
                            selectedVendor?.bankAccountName
                          }
                        />

                        {props.touched.accountholderName &&
                          props.errors.accountholderName && (
                            <p className="text-danger">
                              {props.errors.accountholderName}
                            </p>
                          )} */}
                      </div>
                    </div>{" "}
                    <hr className="mt-2 mb-2"></hr>
                    <h2 className="m-0 pt-2 pb-2">Bank Details</h2>
                    <hr className="mt-2 mb-2"></hr>
                    <div className="mb-3 row mt-3">
                      <label className="w-25 form-label col-3 required">
                        Account Holder Name
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="accountholderName" />

                        {props.touched.accountholderName &&
                          props.errors.accountholderName && (
                            <p className="text-danger">
                              {props.errors.accountholderName}
                            </p>
                          )}
                      </div>
                    </div>{" "}
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Bank Name
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="bankName" />

                        {props.touched.bankName && props.errors.bankName && (
                          <p className="text-danger">{props.errors.bankName}</p>
                        )}
                      </div>
                    </div>{" "}
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Bank Account Number
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="accountNumber" />

                        {props.touched.accountNumber &&
                          props.errors.accountNumber && (
                            <p className="text-danger">
                              {props.errors.accountNumber}
                            </p>
                          )}
                      </div>
                    </div>{" "}
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        IFSC code
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="ifcCode" />

                        {props.touched.ifcCode && props.errors.ifcCode && (
                          <p className="text-danger">{props.errors.ifcCode}</p>
                        )}
                      </div>
                    </div>{" "}
                    <hr />
                    <h3>Line Items :</h3>
                    <hr />
                    <FieldArray name="lineItems">
                      {({ push, remove }) => (
                        <div>
                          {props.values.lineItems.map((lineItem, index) => (
                            <div key={index}>
                              <div className="row g-3 align-items-center">
                                {props?.values?.lineItems?.[index]?.itemFrom !==
                                  "inventory" && (
                                  <div className="col-md">
                                    <label className=" form-label">
                                      Particulars:
                                    </label>
                                    <div className="w-100 col">
                                      <CustomInput
                                        type="text"
                                        name={`lineItems[${index}].particulars`}
                                        // disabled={
                                        //   props.values.paymentfor ===
                                        //   "Vendor Payment"
                                        // }
                                      />
                                    </div>
                                  </div>
                                )}
                                {props?.values?.lineItems?.[index]?.itemFrom ===
                                  "inventory" && (
                                  <div className="col-md">
                                    <label className=" form-label ">
                                      Particulars
                                    </label>

                                    <div className="w-100 col">
                                      <CustomSelect
                                        type="text"
                                        name={`lineItems[${index}].particulars`}
                                        // disabled={
                                        //   props.values.paymentfor ===
                                        //   "Vendor Payment"
                                        // }
                                        value={
                                          props?.values?.lineItems?.[index]?.id
                                        }
                                        onChange={(e) => {
                                          let item = data?.find(
                                            (el) => el.id == e.target.value
                                          );
                                          props.setFieldValue(
                                            `lineItems[${index}].particulars`,
                                            item?.item
                                          );
                                          props.setFieldValue(
                                            `lineItems[${index}].id`,
                                            item?.id
                                          );
                                          props.setFieldValue(
                                            `lineItems[${index}].hsn`,
                                            item?.hsn
                                          );
                                          props.setFieldValue(
                                            `lineItems[${index}].itemUnit`,
                                            item?.unit
                                          );
                                          props.setFieldValue(
                                            `lineItems[${index}].itemPrice`,
                                            item?.cost
                                          );
                                        }}
                                      >
                                        <option value="">Select</option>
                                        {data?.map((el) => {
                                          return (
                                            <option key={el.id} value={el?.id}>
                                              {el?.item}
                                            </option>
                                          );
                                        })}
                                      </CustomSelect>
                                    </div>
                                  </div>
                                )}

                                <div className="col-md">
                                  <label className=" form-label ">
                                    Item units
                                  </label>

                                  <div className="w-100 col">
                                    <CustomSelect
                                      type="text"
                                      name={`lineItems[${index}].itemUnit`}
                                      // disabled={
                                      //   props.values.paymentfor ===
                                      //   "Vendor Payment"
                                      // }
                                    >
                                      <option value="">Select</option>
                                      <option value="nos">Nos</option>
                                      <option value="kg">Kg</option>
                                      <option value="grams">Grams</option>
                                      <option value="ltr">Litter</option>
                                      <option value="ml">ML</option>
                                      <option value="packs">Packs</option>
                                      <option value="pair">Pair</option>
                                      <option value="sqm">SqM</option>
                                      <option value="sqft">SqFt</option>
                                      <option value="mts">Meters</option>
                                      <option value="pcs">Pices</option>
                                    </CustomSelect>
                                  </div>
                                </div>
                                <div className="col-md">
                                  <label className=" form-label ">
                                    Quantity
                                  </label>
                                  <div className="w-100 col">
                                    <CustomInput
                                      type={"text"}
                                      name={`lineItems[${index}].itemQuantity`}
                                      // disabled={
                                      //   props.values.paymentfor ===
                                      //   "Vendor Payment"
                                      // }
                                    />
                                  </div>
                                </div>
                                {/* <div className="col-md">
                                  <label className=" form-label ">
                                    Invoice Number
                                  </label>
                                  <div className="w-100 col">
                                    <CustomInput
                                      type={"text"}
                                      name={`lineItems[${index}].invoicenumber`}
                                    />
                                  </div>
                                </div> */}
                                {/* <div className="col-md">
                                  <label className=" form-label ">
                                    Delivery date
                                  </label>
                                  <div className="w-100 col">
                                    <CustomInput
                                      name={`lineItems[${index}].deliveryDate`}
                                      type="date"
                                    ></CustomInput>
                                  </div>
                                </div> */}
                                <div className="col-md">
                                  <button
                                    className="col-3 btn btn-primary"
                                    style={{
                                      width: "70px",
                                      height: "30px",
                                    }}
                                    type="button"
                                    onClick={() => remove(index)}
                                  >
                                    Remove
                                  </button>
                                </div>
                              </div>
                              <hr />
                            </div>
                          ))}

                          <button
                            className="btn btn-primary mt-2 me-2"
                            type="button"
                            // disabled={
                            //   props.values.paymentfor === "Vendor Payment"
                            // }
                            onClick={() => {
                              if (props.values.lineItems.length === 0) {
                                push({
                                  ...ReqForPayLineItemInfo,
                                });
                              } else if (
                                props.values.lineItems.length > 0 &&
                                checkTouched(
                                  props.values.lineItems[
                                    props.values.lineItems.length - 1
                                  ]
                                )
                              ) {
                                push({
                                  ...ReqForPayLineItemInfo,
                                });
                              } else {
                                Toast(
                                  "error",
                                  "Please fill at least one line item field."
                                );
                              }
                            }}
                          >
                            Add Inventory Item
                          </button>
                          <button
                            className="btn btn-primary mt-2"
                            type="button"
                            // disabled={
                            //   props.values.paymentfor === "Vendor Payment"
                            // }
                            onClick={() => {
                              if (props.values.lineItems.length === 0) {
                                push({
                                  ...ReqForPayLineItemInfo,
                                  itemFrom: "custom",
                                });
                              } else if (
                                props.values.lineItems.length > 0 &&
                                checkTouched(
                                  props.values.lineItems[
                                    props.values.lineItems.length - 1
                                  ]
                                )
                              ) {
                                push({
                                  ...ReqForPayLineItemInfo,
                                  itemFrom: "custom",
                                });
                              } else {
                                Toast(
                                  "error",
                                  "Please fill at least one line item field."
                                );
                              }
                            }}
                          >
                            Add Custom Line Item
                          </button>
                        </div>
                      )}
                    </FieldArray>
                  </div>
                  <div className="card-footer">
                    <div className="btn-list justify-content-end">
                      {/* <FormSubmitButton buttonText="Submit Request For Payment" /> */}
                      <FormSubmitButton
                        buttonText={
                          loading ? "Submitting..." : "Edit Request For Payment"
                        }
                        disabled={props.isSubmitting || loading}
                      />

                      <SimpleButton buttonText="Cancel" type="secondary" />
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default EditReqForPayment;
